import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Heart, UserCheck, Zap, ShieldCheck, Smile } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <Activity className="w-8 h-8" />,
      title: "Chiropractic Adjustments",
      description: "Precise spinal manipulations to restore joint function, reduce pain, and improve nervous system health."
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: "Back & Neck Pain Relief",
      description: "Targeted therapies to alleviate chronic and acute pain in the spine, neck, and lower back areas."
    },
    {
      icon: <UserCheck className="w-8 h-8" />,
      title: "Posture Correction",
      description: "Analysis and corrective plans to fix alignment issues caused by modern lifestyle and work habits."
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: "Sports Injury Recovery",
      description: "Specialized care for athletes to speed up recovery, prevent future injuries, and enhance performance."
    },
    {
      icon: <ShieldCheck className="w-8 h-8" />,
      title: "Mobility & Wellness Care",
      description: "Holistic approaches to improve flexibility, range of motion, and overall physical well-being."
    },
    {
      icon: <Smile className="w-8 h-8" />,
      title: "Personalized Treatment",
      description: "Customized care plans designed specifically for your body's unique needs and health goals."
    }
  ];

  return (
    <section id="services" className="py-24 bg-cream relative">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-text-secondary font-medium tracking-widest uppercase text-sm mb-4 block">Our Expertise</span>
          <h2
            className="text-4xl md:text-5xl font-serif font-bold text-forest mb-6"
            style={{
              color: "#4f5a33"
            }}>Comprehensive Care</h2>
          <p className="text-text-secondary text-lg font-light">
            We offer a wide range of chiropractic services designed to help you achieve optimal health and wellness.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="p-8 rounded-sm hover:shadow-lg transition-all duration-300 border border-transparent hover:border-divider group"
              style={{ backgroundColor: "#4f5a33" }}
            >
              <div className="mb-6 group-hover:scale-110 transition-transform duration-300" style={{ color: "#ffffff" }}>
                {service.icon}
              </div>
              <h3
                className="text-xl font-serif font-bold text-forest mb-4"
                style={{
                  color: "#ffffff"
                }}>{service.title}</h3>
              <p
                className="text-text-secondary leading-relaxed font-light"
                style={{
                  color: "#ffffff"
                }}>
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
